import { BasicSelect, MultiSelect } from "vue-search-select";
import CryptoJS from "crypto-js";
import Pagination from './../../../shared/components/pagination';
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import Loader from './../../../shared/components/loader'
import Treeselect from "@riophae/vue-treeselect";
import TripServices from "../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service";
import UtilityServices from "../../services/utility.service";
import DatePicker from "vue2-datepicker";
import CONSTANT from "../../../shared/constants/constant";
import VueElementLoading from "vue-element-loading";
import Util from "../../../shared/util/util";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Multiselect from "vue-multiselect";
import { Validator } from "vee-validate";
import XLSX from "xlsx";
const moment = require("moment");

export default {
  name: "viewAirline",
  components: {
    VueElementLoading,
    Pagination,
    Loader,
    CustomExpandableTable,
    Multiselect,
    Validator,
    Treeselect,
    DatePicker,
  },
  data: function () {
    return {
      tableArr: [],
      isLoading: false,
      Loader: false,
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      offset: 0,
      isImageLoading: false,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      tableColumn: ["AWB","Pickup Date", "Action"],
      innerTableColumn: [],
      tableItems: [],
      AWB: "",
      shortcuts: false,
      companyName: "",
      companyNamelist: [],
      selectedcompanyName: {
        value: "",
        text: "",
      },
      pickupDate: "",
      ProofOfPickupImages: false,
      popimagearray: [],
      Image: "",
      isDownloadImage: "",
      imageEvent: "",
      fileList: "",
      file: "",
      selectPODoption: "",
      on: "",
      isImageLoading: false,
      caption: "Proof of Pickup Image",
      image: "",
      //  disabledBefore: new Date().setMonth(new Date().getMonth()-1),
      disabledAfter: new Date(),
	  hubnamelist:[],
	  selectedHub:{value:'',text:''},
	  hubname: null,
	  multipleawbflag: false,
    };
  },
  computed: {},
  mounted() {
    this.getCompanyShortName();
    this.getPOPShipment();
	this.getHubList();
  },
  methods: {
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },
    async getCompanyShortName() {
      try {
        var CompanyShortList = [];
        let result = await TripServices.getActiveInactiveClientList();
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.companyNamelist.push({
            id: CompanyShortList[i].ClientMasterID,
            label: CompanyShortList[i].ClientShortName,
            CompanyName: CompanyShortList[i].CompanyName,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
	async getHubList(){
      try{
        let input = {}
		let tempArr = [];
		let result = await  TripServices.GetHublist(input);
		let HubList = result.data.data.data;
		for (var i = 0; i < HubList.length; i++) {
			tempArr.push({
			'value': HubList[i].HubID,
				'text': HubList[i].HubName
			});
		} 
		this.hubnamelist = tempArr
        } catch(err){
         this.isLoading = false;
          console.log(err);
        }
      },
    async getPOPShipment() {
      try {
        this.isLoading = true;
        this.totalCount = 0;
        //  this.tableItems = []
        let inputPayload = {
          offset: this.offset,
          limit: this.pageLimit,
        };
        if (this.AWB != null && this.AWB != "") {
          let awbnumber = this.AWB.split(/[\n,' ']+/);
          let awbarr = awbnumber.filter(function (n) {
            return n !== "";
          });
          if (awbarr.length > 10) {
            this.$alertify.error("Maximum 10 AWB Allowed", "", "error");
            this.isLoading = false;
			this.multipleawbflag = true;
          } else {
            inputPayload.awb = awbarr;
          }
        } else {
          //$("#awb").focus();
          $("#AWB").keydown(function (e) {
            if (e.keyCode === 13) {
              $(this).val("").focus();
              return false;
            }
          });
        }
        if (this.pickupDate[0] && !this.multipleawbflag) {
          inputPayload.pickupdate = this.pickupDate;
        }
        if (this.companyName && !this.multipleawbflag) {
          inputPayload.clientid = this.companyName.id;
        }
		if (this.hubname && !this.multipleawbflag) {
			inputPayload.hubid = this.hubname.value;
		}
        let result = await UtilityServices.getPOPShipment(inputPayload);
        if (result.data.code == 200) {
          this.tableArr = result.data.data.rows;
          this.totalCount = Number(result.data.data.count);
          if (this.totalCount > 0) {
            this.tableItems = result.data.data.rows.map((el) => {
              return {
                id: el.id,
                AWB: el.awb,
                "Pickup Date":Util.displayDateTimeFormat(el.createddate)
              };
            });
          } else {
            this.tableItems = [];
            this.$alertify.error("No Valid Shipment  found", "", "error");
          }
        } else {
          this.$alertify.error("No valid shipment found", "", "error");
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1;
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
    searchPOPShipment() {
      this.currentPage = 1;
      this.offset = 0;
      this.getPOPShipment();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit;
	  this.AWB='';
      this.getPOPShipment();
    },
    clearForm() {
      this.currentPage = 1;
      this.totalCount = 0;
      this.offset = 0;
	  this.multipleawbflag = false;
      (this.AWB = ""), (this.companyName = ""), (this.pickupDate = "");
	  this.hubname =''
      this.getPOPShipment();
      this.$validator.reset();
    },
    async getCustomTableEvent(id) {
      if (id.actionType == "isviewimage") {
        this.popimagearray = [];
        this.ProofOfPickupImages = true;
        this.isImageLoading = true;
        let Id = id.id;
        let input = {
          id: Id,
        };
        let result = await UtilityServices.getPOPShipment(input);
        if (result.data.code == 200) {
          let popimages = result.data.data.rows[0];
          if (
            popimages.podurl.destinationpodimg &&
            popimages.podurl.destinationpodimg.length
          ) {
            popimages.podurl.destinationpodimg.forEach((obj) => {
              this.popimagearray.push(obj);
            });
          }
        } else {
          this.popimagearray = [];
        }
        this.isImageLoading = false;
      }
      if (id.actionType == "isdownloadimage") {
        this.isLoading = true;
        let Id = id.id;
        let input = {
          id: Id,
        };
        let result = await UtilityServices.getPOPShipment(input);
        if (result.data.code == 200) {
          let popimages = result.data.data.rows[0];
          if (
            popimages.podurl.destinationpodimg &&
            popimages.podurl.destinationpodimg.length
          ) {
            this.fileview(popimages.podurl.destinationpodimg);
          }
        } else {
          this.popimagearray = [];
        }
        this.isLoading = false;
      }
    },
    closemodal(id) {
      let modal = document.getElementById(id);
      modal.style.display = "none";
      this.ProofOfPickupImages = true;
    },
    closeProofOfPickupImages() {
      this.popimagearray = [];
      this.ProofOfPickupImages = false;
    },
    openImage(image) {
      this.image = image;
      this.$nextTick(() => {
        let modal = document.getElementById("myModalImg" + image);
        var img = document.getElementById("imgid" + image);
        var modalImg = document.getElementById("img" + image);
        var captionText = document.getElementById("captionImg" + this.caption);
        modal.style.display = "block";
        modalImg.src = image;
        captionText.innerHTML = this.caption;
        this.ProofOfPickupImages = false;
      });
    },
    closemodal(id) {
      let modal = document.getElementById(id);
      modal.style.display = "none";
      this.ProofOfPickupImages = true;
    },
    fileview(index) {
      var link = document.createElement("a");
      link.href = index;
      link.setAttribute("target", "_blank");
      window.open(index, "_blank");
      link.remove();
      return true;
    },
    async exportData() {
      try {
        this.isLoading = true;
        let inputPayload = {};
        if (this.AWB != null && this.AWB != "") {
          let awbnumber = this.AWB.split(/[\n,' ']+/);
          let awbarr = awbnumber.filter(function (n) {
            return n !== "";
          });
          if (awbarr.length > 10) {
            this.$alertify.error("Maximum 10 AWB Allowed", "", "error");
            this.isLoading = false;
            return false;
          } else {
            inputPayload.awb = awbarr;
          }
        } else {
          //$("#awb").focus();
          $("#AWB").keydown(function (e) {
            if (e.keyCode === 13) {
              $(this).val("").focus();
              return false;
            }
          });
        }
		console.log("this.pickupDate[0]",this.pickupDate[0]);
        if (this.pickupDate[0]) {
          inputPayload.pickupdate = this.pickupDate;
        }
        if (this.companyName) {
          inputPayload.clientid = this.companyName.id;
        }
        let result = await UtilityServices.GetAllPOPShipment(inputPayload);
        if (result.data.code == 200) {
          let tempdata = result.data.data.rows.map((el) => {
            return {
              AWB: el.awb,
              "Origin HubName": el.originhubname,
              Description: el.podurl,
              CreatedBy: el.createdby,
              CreatedDate: moment(el.createddate)
                .tz("Asia/Kolkata")
                .format("YYYY-MM-DD HH:mm:ss"),
            };
          });
          let dt = moment().tz("Asia/Kolkata").format("YYYYMMDDHHmmss");
          const data = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, "data");
          XLSX.writeFile(wb, dt + "POP_Data.xlsx");
        } else {
          this.$alertify.error(result.data.message);
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/utility/views/proofofpickup/proofofpickup.component.js